import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap5';

export default function Item({ title, iconClass, onClick }) {
  return (
    <Dropdown.Item onClick={() => onClick()}>
      <div className="icon-with-text">
        <i className={`small-icon ${iconClass}`} />
        <div className="text-content text-lowercase">
          {title}
        </div>
      </div>
    </Dropdown.Item>
  );
}

Item.propTypes = {
  title: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

Item.defaultProps = {
  onClick: () => {},
};
